module.exports = __webpack_public_path__ + "static/media/scr_simple_numeric_keypad_with_1234.991e9c2e.png";